<div class="video-only-train-question mx-auto text-center">
  {{ card().frontText || t()["train.noQuestionText"] }}
</div>

<div
  class="video-only-train-media d-flex align-items-center justify-content-center"
  [class.video-only-train-media--with-text-simple-back]="
    isTextSimpleBackVisible()
  "
>
  @if (videoAsset(); as video) {
    <app-vidstack-player
      class="video-only-train-video rounded border bg-black"
      [src]="video.url"
      mediaType="video"
      [title]="videoLabel"
      preload="metadata"
    ></app-vidstack-player>
  } @else {
    <div class="video-only-train-unavailable text-body-secondary text-center">
      {{ t()["train.noQuestionText"] }}
    </div>
  }
</div>

@if (canSpeakQuestion()) {
  <button
    type="button"
    class="train-front-action train-question-audio-action btn btn-icon btn-outline-primary rounded-circle waves-effect"
    [class.train-audio-action-playing]="isQuestionAudioPlaying()"
    [attr.aria-label]="t()['train.listenQuestion']"
    [title]="t()['train.listenQuestion']"
    (click)="speak.emit()"
  >
    <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
      <use href="/assets/icons/sprite.svg#volume-2"></use>
    </svg>
  </button>
}
